import React from 'react';
import {inject, observer} from 'mobx-react';
import QRCode from 'qrcode.react';

@inject('portalLoginStore')
@observer
class E9QRCode extends React.Component {
    constructor(props) {
        super(props);
        this.onDownload = this.onDownload.bind(this);
    }

    componentDidMount() {
        const {portalLoginStore} = this.props;
        const {state = {}} = portalLoginStore;
        const {cacheAccount:loginId, langId} = state;
        portalLoginStore.getLoginForm({loginId, langId}, true);

        this.getQRCode();
    }

    componentDidUpdate() {
        this.getQRCode();
    }

    componentWillUnmount() {
        window.clearInterval(this.scanInterval);
    }

    render() {
        const {portalLoginStore} = this.props;
        const {labelObj, downloadUrl, state = {}} = portalLoginStore;
        const {loginSettingInfo = {}, qrcode} = state;
        const {loginForm = {}} = loginSettingInfo;

        const size = this.props.size || 180;
        const color = this.props.color || loginForm.color || '#fff';

        return (
            <div className="e9login-QRCode">
                <div className="e9login-QRCode-area">
                    {!!qrcode ? <QRCode value={qrcode.text} size={size} fgColor="#404549" bgColor="#eaeaea"/> : ''}
                </div>
                <div className="e9login-QRCode-describe" style={{color}}>{labelObj.qrcode}</div>
                {downloadUrl && <div className="e9login-QRCode-download" style={{color}} onClick={this.onDownload}>{labelObj.download}</div>}
            </div>
        );
    }

    getQRCode() {
        const {portalLoginStore} = this.props;
        const {state = {}} = portalLoginStore;
        const {qrcode} = state;

        if (!!qrcode) {
            window.clearInterval(this.scanInterval);
            this.scanInterval = window.setInterval(this.scanQRCode.bind(this), 1000);
        }
    }

    scanQRCode() {
        const {portalLoginStore} = this.props;
        portalLoginStore.onQCLogin();
    }

    onDownload() {
        const {portalLoginStore} = this.props;
        const {downloadUrl} = portalLoginStore;
        window.open(downloadUrl);
    }
}

export default E9QRCode;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e9login/E9QRCode.js